/**class，function运行正常后可删除该文件 */
import React from 'react'
import {ReactSiema} from '../../components/reactSiema/ReactSiema'
import * as Sentry from '@sentry/browser'
import {connect} from 'react-redux'
import {fetchPosts, requestFailed} from '../../store/dailyReport/actions'
import {RootState, ReportType} from '../../store/dailyReport/types'
import {Retry} from '../../components/retry/Retry'
import {Loading} from '../../components/loading/Loading'
import {Skeleton} from '../../components/skeleton/Skeleton'
import {DailyReportCard} from '../../components/dailyReportCard/DailyReportCard'
import {ThunkDispatch} from 'redux-thunk'
import {AnyAction, compose} from 'redux'
import {setNavRightButton, trackNew, triggerAction} from '../../utils/bridge'
import {Toast} from '../../components/antd/Antd'
import {isAndroid} from "../../utils/bridge/utils";

interface AppProps {
  reports: ReportType[],
  since: string,
  isFetching: boolean,
  allLoaded: boolean,
  lenLastFetch: number,
  isFirstFetch: boolean,
  status: boolean
}

type DispatchToPropsType = Readonly<{
  fetchReport: any,
  handleFail: (param: boolean) => void
}>

interface Istate {
  reportsShow: ReportType[] //不直接用this.props.reports的原因是为了控制页面的刷新时机
}

const pageID = 'p_mytantan'

class App extends React.Component<AppProps & DispatchToPropsType, Istate> {
  constructor(props: AppProps & DispatchToPropsType) {
    super(props)
    this.state = {
      reportsShow: []
    }
  }

  lastPage = 0;
  indexToday = 0;
  retryListening = false;
  slider: ReactSiema | null = null;

  goToToday = () => {
    const {reports} = this.props
    if (this.slider) {
      this.slider.goTo(reports.length - 1)
    }
  };
  // eslint-disable-next-line complexity
  getReports = async () => {
    const {fetchReport, handleFail} = this.props
    if (this.retryListening) {
      this.unbindRetryListener()
    }
    if (this.props.allLoaded || this.props.isFetching) {
      return
    }
    try {
      // if (!window.navigator.onLine) {
      //   const msg = window.navigator.onLine ? '获取日报失败' : '网络连接断开'
      //   Toast.info(msg, 0.5)
      //   return
      // }
      await fetchReport()
    } catch (error) {
      const msg = window.navigator.onLine ? '获取日报失败' : '网络连接断开'
      Toast.info(msg)
      if (this.props.reports.length === 0) {
        this.bindRetryListener()
      }
      handleFail(false)
      Sentry.withScope((scope) => {
        scope.setExtra('error', error)
        Sentry.captureException(error)
      })
    }
    /**更新本日index */
    this.indexToday = this.props.reports.length - 1
    if (this.slider) {
      /**在现有的日报卡片前面增加新的卡片*/
      this.slider.currentSlide = this.props.lenLastFetch
    }
    // 首次请求
    if (this.props.isFirstFetch) {
      this.lastPage = this.indexToday
    }
    console.log(this.props.reports)
    this.setState({reportsShow: this.props.reports})
  };

  onPageChange = () => {
    const {lastPage, indexToday} = this
    const currentSlide = this.slider ? this.slider.currentSlide : null
    this.lastPage = currentSlide ? currentSlide : 0

    this.trackMV(this.lastPage)

    // 排除页数没变和只有一页的情况
    if (currentSlide === lastPage || indexToday <= 0) {
      return
    }

    // 如果当前页变成了今天，去掉右上角的按钮
    if (currentSlide === indexToday) {
      if (isAndroid) {
        triggerAction({
          actionType: 'unRegisterBarRight',
        })
      } else {
        setNavRightButton({
          text: ' ',
          handler: () => {}
        })
      }
    }

    // 如果上一个页面是今天，那么加上右上角的按钮
    if (lastPage === indexToday) {
      const imgUrl = isAndroid
        ? 'https://auto.tancdn.com/v1/images/eyJpZCI6IjZCVUhKM0FIUklDS080QkEzRzZYRTRET0lBN0pPWjA2IiwidyI6MjIsImgiOjIyLCJkIjowLCJtdCI6ImltYWdlL2pwZWciLCJkaCI6MTYzNTY1MjI2MzcxNDU4MjU3N30.png'
        : 'https://auto.tancdn.com/v1/images/eyJpZCI6Ik9YSlhJQUdDUDdBRE9aSExZUUFBSkFCUUcyRVdLRjA5IiwidyI6MTMyLCJoIjoxMzIsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjo0MzI0MzE0MDYyMzkxODc0NzJ9.png'
      if (isAndroid) {
        triggerAction({
          actionType: 'registerBarRight',
          restParams: {
            key: 'mytantan',
            callback: this.goToToday,
          },
        })
      } else {
        setNavRightButton({
          imgUrl: imgUrl,
          handler: this.goToToday
        })
      }
    }
  };
  bindRetryListener = () => {
    this.retryListening = true
    window.addEventListener('touchstart', this.getReports)
  };

  unbindRetryListener = () => {
    this.retryListening = false
    window.removeEventListener('touchstart', this.getReports)
  };

  async componentDidMount() {
    await this.getReports()
    this.trackMV(4)
  }

  trackMV(index: number) {
    const date = this.props.reports[index]?.report_date
    console.log(date)
    trackNew({
      pageId: pageID,
      eid: 'e_dailyreport',
      type: 'MV',
      extras: {date}
    })
  }

  render() {
    const {
      allLoaded,
      isFetching,
    } = this.props
    const {reportsShow} = this.state
    /**获取日报数为0 */
    if (reportsShow.length === 0 && !isFetching) {
      return <Retry/>
    }
    /**正在获取日报 */
    if (isFetching && reportsShow.length === 0) {
      return (<Skeleton/>)
    }
    return (
      <React.Fragment>
        {
          (reportsShow.length > 0 && !allLoaded) && <Loading/>
        }
        <ReactSiema
          startIndex={Math.max(0, reportsShow.length - 1)}
          duration={200}
          ref={siema => this.slider = siema}
          onLoadPrevious={this.getReports}
          onChange={this.onPageChange}>
          {
            reportsShow.map(r => (
              <DailyReportCard
                date={r.report_date}
                key={r.report_date}/>
            ))
          }
        </ReactSiema>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state: RootState) => {

  const {reports, since, isFetching, allLoaded, lenLastFetch, isFirstFetch, status} = state.dailyReport
  return {
    reports,
    since,
    isFetching,
    allLoaded,
    lenLastFetch,
    isFirstFetch,
    status
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, void, AnyAction>): DispatchToPropsType => {
  return {
    fetchReport: compose(dispatch, fetchPosts),
    handleFail: compose(dispatch, requestFailed),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(App)
